/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import React from 'react';
import { RiEmotionSadLine } from 'react-icons/ri';
import { useAppSelector } from '../state/hooks';
import { useDispatch } from 'react-redux';
import { actionCreators } from '../state';
import { bindActionCreators } from 'redux';
import { BiArrowBack } from 'react-icons/bi';
import './ErrorInfo.css';
import './BackNavigation.css';
import Helper from '../settings/helperFunctions';
import { useTrackingPageLoad } from '../services/tracking';

export type ErrorInfoProps = {
  properties: {
    name: string;
    showOnSteps: Array<number>;
  };
  labels: {
    defaultTitle: AppLabels;
    title: AppLabels;
    info: AppLabels;
    leerPlansearchInfo: AppLabels;
    phoneTitle: AppLabels;
    phone: AppLabels;
    serviceTime: AppLabels;
    stepBack: AppLabels;
  };
};

const ErrorInfo = (props: ErrorInfoProps) => {
  props = Helper.mergeProps(props, defaultConfigs);
  const dispatch = useDispatch();
  const { currentSteps, sessionId } = useAppSelector((state) => state.settingsReducer);
  const { footerConfig, globalConfig } = useAppSelector((state) => state.skinReducer);
  const { errorInfoText, errorType, trackingPageName } = useAppSelector(
    (state) => state.errorReducer,
  );
  const { setCurrentSteps, setErrorInfoText, setErrorType } = bindActionCreators(
    actionCreators,
    dispatch,
  );

  useTrackingPageLoad({ name: trackingPageName + 'Fehler', conversionType: '' });

  const goBack = () => {
    let tmp = [...currentSteps];
    tmp.pop();
    setCurrentSteps([...tmp]);
    setErrorInfoText('');
    setErrorType('');
  };
  // 1000 = default, 1001 = not default
  let errorTitle =
    currentSteps[currentSteps.length - 1] === 1000
      ? Helper.getLabel(props.labels.defaultTitle)
      : Helper.getLabel(props.labels.title);

  const globalData = Helper.buildData();
  let data = {
    sessionId: sessionId,
    errorType: errorType,
    hotline: globalData.hotline,
  };
  errorTitle = Helper.evalString(errorTitle, data);
  return (
    <div
      data-component={props.properties.name}
      css={{
        backgroundColor: globalConfig.primary.defaultBackground,
        borderColor: footerConfig.default.text,
      }}
      className="errorInfoContainer">
      <RiEmotionSadLine size={50} color={footerConfig.default.link} />
      <p
        css={{ color: footerConfig.default.text }}
        className="errorInfoTitle"
        dangerouslySetInnerHTML={{ __html: errorTitle }}></p>
      {currentSteps[currentSteps.length - 1] === 1001 && (
        <div className="errorInfoTextContainer">
          <div
            css={{ color: footerConfig.default.link }}
            className="errorInfoSubtitle"
            dangerouslySetInnerHTML={{ __html: errorInfoText }}></div>
          <p css={{ color: footerConfig.default.link }} className="errorInfoInfoText">
            {errorType !== 'KeineProdukteGefunden'
              ? Helper.evalString(Helper.getLabel(props.labels.info), data)
              : Helper.getLabel(props.labels.leerPlansearchInfo)}
          </p>
          <p css={{ color: footerConfig.default.link }} className="errorInfoPhoneTitle">
            {Helper.evalString(Helper.getLabel(props.labels.phoneTitle), data)}
          </p>
          <p css={{ color: footerConfig.default.link }} className="errorInfoPhone">
            {Helper.evalString(Helper.getLabel(props.labels.phone), data)}
          </p>
          <p css={{ color: footerConfig.default.link }} className="errorInfoOpeningTimes">
            {Helper.evalString(Helper.getLabel(props.labels.serviceTime), data)}
          </p>
          <div
            onClick={() => goBack()}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                goBack();
              }
            }}
            tabIndex={0}
            role="button"
            aria-label={Helper.getLabel(props.labels.stepBack)}
            className="backNavigationContainer">
            <BiArrowBack size={20} color={footerConfig.default.link} />
            <span css={{ color: footerConfig.default.link }} className="backNavigationText">
              {Helper.getLabel(props.labels.stepBack)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const defaultConfig: ErrorInfoProps = {
  properties: {
    name: 'ErrorInfo',
    showOnSteps: [],
  },
  labels: {
    title: {
      de: 'Leider können wir Ihnen kein Angebot erstellen.',
      en: 'Leider können wir Ihnen kein Angebot erstellen._en',
    },
    defaultTitle: {
      de: 'Aufgrund einer technischen Störung steht Ihnen unser Buchungsassistent aktuell nicht zur Verfügung. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut. Vielen Dank.',
      en: 'Aufgrund einer technischen Störung steht Ihnen unser Buchungsassistent aktuell nicht zur Verfügung. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut. Vielen Dank._en',
    },
    info: {
      de: 'Bitte wenden Sie sich an das ServiceCenter der ERGO Reiseversicherung oder direkt an Ihren Vermittler.',
      en: 'Bitte wenden Sie sich an das ServiceCenter der ERGO Reiseversicherung oder direkt an Ihren Vermittler._en',
    },
    leerPlansearchInfo: {
      de: 'Bitte wenden Sie sich deshalb direkt an Ihren Vermittler oder an das ServiceCenter der ERGO Reiseversicherung.',
      en: 'Bitte wenden Sie sich deshalb direkt an Ihren Vermittler oder an das ServiceCenter der ERGO Reiseversicherung._en',
    },
    phoneTitle: {
      de: 'Telefon:',
      en: 'Telefon:_en',
    },
    phone: {
      de: '(data.hotline.phone)',
      en: '(data.hotline.phone)',
    },
    serviceTime: {
      de: '(data.hotline.serviceTime)',
      en: '(data.hotline.serviceTime)',
    },
    stepBack: {
      de: 'Schritt zurück',
      en: 'Schritt zurück_en',
    },
  },
};
export const defaultConfigs = { default: defaultConfig };

export default ErrorInfo;
